<template>
    <div class="tags is-marginless">
        <span v-for="tag in tags" :key="tag" class="tag is-light">{{
            tag
        }}</span>
    </div>
</template>

<script>
export default {
    props: {
        tags: {
            type: Array,
            default: () => {
                return [];
            },
        },
    },
};
</script>

<style scoped>
.tags {
    padding-top: 0.5rem;
}
.tags .tag:first-child {
    margin-left: 0;
}
</style>
